export default function autoBind(self) {
  const prototype = Object.getOwnPropertyNames(self.constructor.prototype);

  prototype.forEach(method => {
    self[method] = self[method].bind(self);
  });
}
